import { Prose } from '@/components/Prose';
import { RichTextBoxTheme } from '@/components/RichTextBox/theme';
import { GenericSlot } from 'base/components/GenericSlot';

export const RichTextBox = GenericSlot({ as: Prose, theme: RichTextBoxTheme });
